var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10518_26080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 16C17 17.5823 16.5308 19.129 15.6518 20.4446C14.7727 21.7602 13.5233 22.7855 12.0615 23.391C10.5997 23.9965 8.99113 24.155 7.43928 23.8463C5.88743 23.5376 4.46197 22.7757 3.34315 21.6569C2.22433 20.538 1.4624 19.1126 1.15372 17.5607C0.84504 16.0089 1.00347 14.4003 1.60897 12.9385C2.21447 11.4767 3.23985 10.2273 4.55544 9.34824C5.87103 8.46919 7.41775 8 9 8C11.121 8.00232 13.1545 8.84591 14.6543 10.3457C16.1541 11.8455 16.9977 13.879 17 16ZM23 8C22.29 8 20.95 8.345 19.96 10.6562C19.3413 12.1 19 14 19 16C19 18 19.3413 19.9 19.96 21.3438C20.95 23.655 22.29 24 23 24C23.71 24 25.05 23.655 26.04 21.3438C26.6588 19.9 27 18 27 16C27 14 26.6588 12.1 26.04 10.6562C25.05 8.345 23.71 8 23 8ZM30 8C29.7348 8 29.4804 8.10536 29.2929 8.29289C29.1054 8.48043 29 8.73478 29 9V23C29 23.2652 29.1054 23.5196 29.2929 23.7071C29.4804 23.8946 29.7348 24 30 24C30.2652 24 30.5196 23.8946 30.7071 23.7071C30.8946 23.5196 31 23.2652 31 23V9C31 8.73478 30.8946 8.48043 30.7071 8.29289C30.5196 8.10536 30.2652 8 30 8Z",
    fill: "#D5D6D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10518_26080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.61ddd09aeb692cdbc475638bcb4923f2.svg";
export { ForwardRef as ReactComponent };